import React from "react"

export function Divider() {
  return (
    <div className="m-2 p-2">
      <hr />
    </div>
  )
}
